///operator/audio/pre-recorded

import apiCall from "../../axios";
const orchidPreRecordedAudio = async (payload: any) => {
  try {
    const res = await apiCall("POST", `operator/audio/orchid-pre-recorded`, payload);
    return res.data;
  } catch (e) {
    if (e) return e;
    return { error: "Unknown Error" };
  }
};

export default orchidPreRecordedAudio;
